import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
import SendIcon from '@mui/icons-material/Send';
import SuccesDialog from '../../../components/reusable/SuccesDialog';
import ErrorDialog from '../../../components/reusable/ErrorDialog';

const TimesheetSend = (props) => {
    const { confirmDialog, setConfirmDialog, setMessage } = props;
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [returnDialog, setReturnDialog] = useState({
        open: false,
        type: '',
        message: '',
    });
    const navigate = useNavigate();
    const { mission_planning_id = null, agenda_id = null, timesheet_id = null } = confirmDialog ?? {};

    const handleSendTimesheet = async () => {
        setLoadingBackdrop(true);
        setDisabled(true);
        try {
          const result = await TimeSheetMissionService.sendAndGenerate(mission_planning_id, agenda_id, timesheet_id);
          if(result && result.status){
            setReturnDialog({ open: true, type: 'success', message: 'La feuille de temps a été envoyée avec succès.' });
            onCloseDialog();
            setTimeout(() => {
            setReturnDialog({ open: false, type: '', message: '' });
            navigate('/mission/timesheet');
            }, 1000);
          } else {
            setReturnDialog({ open: true, type: 'error', message: result.message || "Une erreur est survenue lors de l'envoi de la feuille de temps." });
          }
        } catch (error) {
          setReturnDialog({ open: true, type: 'error', message: error.message });
        }
        finally {
          setLoadingBackdrop(false);
          setDisabled(false);
          
        }
      };

      const onCloseDialog = () => {
        setConfirmDialog({
                open: false,
                mission_planning_id: null,
                agenda_id: null,
                timesheet_id: null,
              });
      };

    return (
      <>
        <Dialog
              open={confirmDialog.open}
              onClose={onCloseDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                {"Confirmation d'envoi timesheet"}
              </DialogTitle>
              
              <DialogContent id="alert-dialog-description" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} dividers>
                <DialogContentText  >
            <LoadingSimpleBackdrop openLoadingSimpleBackdrop={loadingBackdrop} />
                   <label sx={{ fontSize: '10px' }}>Souhaitez-vous confirmer <strong>l'envoi de la timesheet de la mission</strong> au responsable ?</label>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={onCloseDialog} variant='contained' color='error' disabled={disabled}>
                  Fermer
                </Button>
                <Button startIcon={loadingBackdrop ? <LoadingSimpleBackdrop openLoadingSimpleBackdrop={loadingBackdrop} /> : <SendIcon />}
                onClick={() => handleSendTimesheet()} autoFocus disabled={disabled} variant='contained' color='info'>
                  Envoyer
                </Button>
              </DialogActions>
            </Dialog>
            <SuccesDialog open={returnDialog.open && returnDialog.type === 'success'} onClose={() => setReturnDialog({ ...returnDialog, open: false })} message="La timesheet a été envoyée avec succès." />
              <ErrorDialog  open={returnDialog.open && returnDialog.type === 'error'} onClose={() => setReturnDialog({ ...returnDialog, open: false })} message={returnDialog.message || "Une erreur est survenue lors de l'envoi de la timesheet."} />
            </>
    );
}

export default TimesheetSend;
